import { useCallback, useState } from 'react';

import { deleteClientInsight } from 'api/generated/client-insights/client-insights';

export interface UseDeleteClientInsightResult {
  deleteInsight: (args: {
    userId: string;
    clientId: number;
    insightId: number;
  }) => Promise<void>;
  isDeleting: boolean;
}

export const useDeleteClientInsight = (): UseDeleteClientInsightResult => {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteInsight = useCallback(
    async (args: {
      userId: string;
      clientId: number;
      insightId: number;
    }): Promise<void> => {
      setIsDeleting(true);

      try {
        await deleteClientInsight(args.userId, args.clientId, args.insightId);
      } finally {
        setIsDeleting(false);
      }
    },
    [],
  );

  return { deleteInsight, isDeleting };
};
